import React, { useEffect, useState } from "react";
import API from "../services/api";
import Sidebar from "../components/Sidebar";
import { toast } from "react-toastify";

function Recommendations() {
  const [dashboard, setDashboard] = useState(null);
  const [recommendations, setRecommendations] = useState([]);

  useEffect(() => {
    fetchDashboard();
    fetchRecommendations();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await API.get("/dashboard/summary");
      setDashboard(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchRecommendations = async () => {
    try {
      const res = await API.get("/recommendations");
      setRecommendations(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const addDemoRecommendation = async () => {
    try {
      await API.post("/recommendations/add", {
        recommendation_type: "compost_health",
        recommendation_text:
          "Focus on establishing proper bedding and introducing worms gradually.",
        priority: "medium"
      });

      toast.success("Recommendation generated");
      fetchRecommendations();
    } catch {
      toast.error("Generation failed");
    }
  };

  const deleteRecommendation = async (id) => {
    try {
      await API.delete(`/recommendations/${id}`);
      toast.success("Deleted");
      fetchRecommendations();
    } catch {
      toast.error("Delete failed");
    }
  };

  const progress =
    dashboard?.total_days > 0
      ? Math.round(
          (dashboard.current_day / dashboard.total_days) * 100
        )
      : 0;

  const healthScore = dashboard?.health_score || 85;

  const getHealthStatus = () => {
    if (healthScore >= 80) return "Good";
    if (healthScore >= 60) return "Moderate";
    return "Critical";
  };

  const getHealthBadge = () => {
    if (healthScore >= 80) return "bg-success";
    if (healthScore >= 60) return "bg-warning";
    return "bg-danger";
  };

  return (
    <div className="dashboard-layout">
      <Sidebar />

      <div className="main-content">
        <div className="container-fluid">

          {/* Photo Reminder */}
          <div className="card dashboard-card photo-card mb-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h5>📷 Daily Photo Reminder</h5>
                <p>
                  Capture a quick photo of your vermibed
                  to track daily progress.
                </p>
              </div>

              <button className="btn btn-success">
                Take Today's Photo
              </button>
            </div>
          </div>

          {/* Summary */}
          <div className="row g-4 mb-4">
            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Current Day</h6>
                <h2>
                  {dashboard?.current_day || 0}/
                  {dashboard?.total_days || 60}
                </h2>

                <small>
                  {(dashboard?.total_days || 60) -
                    (dashboard?.current_day || 0)} days remaining
                </small>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Current Phase</h6>

                <span className="badge bg-primary p-2">
                  {dashboard?.current_phase || "Not Started"}
                </span>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Progress</h6>

                <div className="progress mb-2">
                  <div
                    className="progress-bar bg-success"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>

                <h4>{progress}%</h4>
              </div>
            </div>
          </div>

          {/* AI Recommendations Main */}
          <div className="card dashboard-card mb-4">
            <div className="d-flex justify-content-between align-items-start flex-wrap">
              <div>
                <h3>🧠 AI Recommendations</h3>
                <p className="text-muted">
                  Smart suggestions for optimal vermicomposting
                </p>
              </div>

              <button
                className="btn btn-primary"
                onClick={addDemoRecommendation}
              >
                Generate Advice
              </button>
            </div>

            {/* Health Meter */}
            <div className="mt-4">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5>Compost Health Meter</h5>

                <span className={`badge ${getHealthBadge()}`}>
                  {getHealthStatus()}
                </span>
              </div>

              <div className="progress mb-2">
                <div
                  className="progress-bar bg-success"
                  style={{ width: `${healthScore}%` }}
                ></div>
              </div>

              <h5>{healthScore}/100</h5>
            </div>

            {/* Recommendations */}
            <div className="mt-4">
              {recommendations.length > 0 ? (
                recommendations.map((item) => (
                  <div
                    key={item.id}
                    className="recommendation-card"
                  >
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <strong>
                          {item.recommendation_type}
                        </strong>

                        <p className="mb-0 mt-2">
                          {item.recommendation_text}
                        </p>
                      </div>

                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() =>
                          deleteRecommendation(item.id)
                        }
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="recommendation-card">
                  Focus on establishing proper bedding
                  and introducing worms gradually.
                </div>
              )}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Recommendations;